import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=09d5240e&scoped=true&"
import script from "./Splash.vue?vue&type=script&lang=js&"
export * from "./Splash.vue?vue&type=script&lang=js&"
import style0 from "./Splash.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Splash.vue?vue&type=style&index=1&id=09d5240e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5240e",
  null
  
)

export default component.exports